import * as React from 'react';

import { useQuery } from '@apollo/client';
import { StatsigProvider } from '@coursera-web/statsig';

import StoreProviderWrapper from 'bundles/ai-coach-platform/components/patterns/chat/store/StoreProviderWrapper';
import DiscoveryCollectionsQuery from 'bundles/browse-common/legacy/queries/DiscoveryCollectionsQuery.graphql';
import type {
  DiscoveryCollectionsQuery as DiscoveryCollectionsQueryData,
  DiscoveryCollectionsQueryVariables,
} from 'bundles/browse-common/legacy/queries/__generated__/DiscoveryCollectionsQuery';
import SearchBarContentWrapper from 'bundles/search-common/components/searchbar/SearchBarContentWrapper';
import { getItemsListFromLocalStorageByKeyAndTrimOutdated } from 'bundles/search-common/utils/SearchUtils';

type Props = {
  hideSearch?: boolean;
  searchIsOpen?: boolean;
  hideMobileSearchPage?: () => void;
  isChatComposer?: boolean;
  placeholder?: string;
};

const SearchBar = ({ searchIsOpen, hideMobileSearchPage, hideSearch, isChatComposer, placeholder }: Props) => {
  const { data } = useQuery<DiscoveryCollectionsQueryData, DiscoveryCollectionsQueryVariables>(
    DiscoveryCollectionsQuery,
    {
      skip: getItemsListFromLocalStorageByKeyAndTrimOutdated('recently-viewed').length >= 4,
      variables: {
        contextType: 'PAGE',
        contextId: 'autocomplete-repeat-search-state',
      },
      context: { clientName: 'gatewayGql' },
      ssr: false,
    }
  );
  const collectionRecommendations = data?.DiscoveryCollections?.queryCollections?.[0];

  if (hideSearch) return null;

  return (
    <StatsigProvider>
      <StoreProviderWrapper>
        <SearchBarContentWrapper
          collectionRecommendations={collectionRecommendations}
          searchIsOpen={searchIsOpen}
          hideMobileSearchPage={hideMobileSearchPage}
          searchBarConfig={{}}
          isChatComposer={isChatComposer}
          placeholder={placeholder}
        />
      </StoreProviderWrapper>
    </StatsigProvider>
  );
};

export default SearchBar;
